import axios from 'axios';
import { createPayload } from '@/utils/createPayload';
import { reportSilentError } from '@/utils/storeErrorReporting';
import { API_DOMAIN, authHeaders, parseResponse } from '@/api/headers';

export const fetchEducatorFromId = async (educatorId) => {
    try {
        const { token } = await createPayload(null);

        if (!educatorId || typeof educatorId !== 'string') {
            throw new Error('Educator ID provided was invalid');
        }

        const response = await axios.get(`${API_DOMAIN}/educators/${educatorId}`, {
            headers: authHeaders(token),
        });

        return response?.data;
    } catch (error) {
        reportSilentError(error);
        return undefined;
    }
};

/**
 * Creates an Educator record in Career Connect BE.
 */
export const createEducator = async (deEducatorMetadata) => {
    try {
        const { id: educatorId } = deEducatorMetadata;

        if (!educatorId || typeof educatorId !== 'string') {
            throw new Error('Educator ID provided was invalid');
        }

        const { token } = await createPayload(null);
        const response = await axios.post(`${API_DOMAIN}/educators/${educatorId}`, deEducatorMetadata, {
            headers: authHeaders(token),
        });

        return response.data;
    } catch (error) {
        reportSilentError(error);
        return null;
    }
};

/**
 * Fetches the educator's onboarding data (including selected subjects) from the DE proxy.
 * @returns {Promise<Object|undefined>} Onboarding response body, or undefined if the request failed
 */
export const fetchOnboarding = async () => {
    try {
        const { token } = await createPayload(null);

        const response = await fetch(`${API_DOMAIN}/deproxy/v1/onboarding`, {
            headers: authHeaders(token),
        });

        return await parseResponse(response);
    } catch (error) {
        reportSilentError(error);
        return undefined;
    }
};
